import React from "react";
import { useNotifications } from "../../../../hooks/useNotifications";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import { toTitleCase } from "../../../../common/TotitleCase";
import formatDate from "../../../../common/DateFormate";
const AllNotification = () => {
    const { notifications, getTypeConfig, getPriorityStyle } = useNotifications();
    const navigate = useNavigate();
    return (
        <>
        <Breadcrumb title="Notification"/>
            {/* Related Notifications */}
            {notifications.length > 0 ? (
                <div
                    className="related-notifications-card card border-0 shadow-lg mt-2"
                    style={{
                        overflow: 'hidden',
                        animation: 'fadeIn 0.8s ease 0.3s backwards'
                    }}
                >
                    <div className="card-body p-0">
                        {notifications
                            .map((n, index) => {
                                const relatedCfg = getTypeConfig(n.priority,n.type);
                                return (
                                    <div
                                        key={n.id}
                                        className="related-item p-3 border-bottom cursor-pointer"
                                        style={{
                                            animation: `slideInRight 0.5s ease ${index * 0.1}s backwards`
                                        }}
                                        // onClick={() => navigate(`/notification/${n.ticket_id}`)}
                                        onClick={() => navigate(`/notification/${n.ticket_id}`)}
                                    >
                                        <div className="d-flex align-items-center gap-3">
                                            <div
                                                className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: '48px',
                                                    height: '48px',
                                                    background: relatedCfg.gradient,
                                                    border: `2px solid ${relatedCfg.color}30`
                                                }}
                                            >
                                                <i
                                                    className={`${relatedCfg.icon} text-white`}
                                                    style={{ color: relatedCfg.color }}
                                                ></i>
                                            </div>

                                            <div className="flex-grow-1 overflow-hidden" style={{color: "#1e293b",fontWeight: n.isRead ? "" : "700",}}>
                                                {/* <h6 className="kpi-name" style={{ color: '#1e293b' }}>
                                                    {toTitleCase(n.title)}
                                                </h6> */}
                                                <div className="d-flex justify-content-between align-items-center mt-1">
                                                <h6 className="kpi-name" style={{color: "#1e293b",fontWeight: n.isRead ? "" : "700",}}>
                                                    {toTitleCase(n.title)}
                                                </h6>
                                                <div className="small text-nowrap ms-2 notification-date">
                                                    {formatDate(n.created_at)}
                                                </div>
                                                </div>
                                                <p
                                                    className="mb-0 small text-truncate"
                                                    style={{
                                                        maxWidth: '100%',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        fontWeight: n.isRead ? "" : "700"
                                                    }}
                                                >
                                                    {n.message}
                                                </p>
                                            </div>

                                            <i
                                                className="bi bi-chevron-right text-muted flex-shrink-0"
                                                style={{ fontSize: '1.2rem' }}
                                            ></i>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            ) : (<div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 text-center">
                        <div className="not-found-card p-5 rounded-4 shadow-lg">
                            <div className="icon-wrapper mb-4">
                                <i className="bi bi-inbox display-1 text-muted"></i>
                            </div>
                            <h3 className="fw-bold mb-3">Notification Not Found</h3>
                            <p className="text-muted mb-4">
                                The notification you're looking for doesn't exist or has been removed.
                            </p>
                            <button
                                className="btn btn-primary btn-lg rounded-pill px-5 shadow-sm"
                                onClick={() => navigate(-1)}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    border: 'none',
                                    fontWeight: '600'
                                }}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                Go Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>)}
        </>
    )
}
export default AllNotification;